import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private dato: any;
  setDato(valor: any) {
    this.dato = valor;
  }
  getDato() {
    return this.dato;
  }
}
